import * as React from "react";

import { ResponsivenessSetting, useResponsiveness } from "../hooks";

import {
  useProductListPresentationModelFacets,
  useProductListState,
  usePlpPresenterForTheFilterMenu_Desktop,
} from "../providers";

import { Filter } from "./Filter";
import { AppliedFilters } from "./applied-filters";
import {DesktopSorting} from "../desktop-sorting";
import { IS_HORIZONTAL_FILTER_ENABLED } from "../flags";

const DesktopFilterMenu_Controller: React.FunctionComponent = () => {
  const { shouldShowTheFilterMenu_onDesktop } = usePlpPresenterForTheFilterMenu_Desktop();

  const [responsivenessSetting] = useResponsiveness();

  const showDesktopFilters = React.useMemo(() => {
    return (
      responsivenessSetting === ResponsivenessSetting.Desktop &&
      shouldShowTheFilterMenu_onDesktop
    );
  }, [responsivenessSetting, shouldShowTheFilterMenu_onDesktop]);

  if (!showDesktopFilters) {
    return null;
  }

  return <DesktopFilterMenu_View />;
};

const DesktopFilterMenu_View: React.FunctionComponent = () => {
  const { selectedOptions } = useProductListState();
  const { presentationFacets } = useProductListPresentationModelFacets();

  const filters = React.useMemo(() => {
    return presentationFacets.map((presentationFacet) => {
      return (
        <Filter
          key={presentationFacet.key}
          presentationFacet={presentationFacet}
        />
      );
    });
  }, [presentationFacets]);
  return (
    <div
      aria-label="desktop filter menu"
      className={`desktop-filter-menu-container ${
        selectedOptions.length > 0 ? "has-applied-filters" : ""
      }`}
    >
      <ul aria-label="filter list" className="desktop-filter-menu">
        {IS_HORIZONTAL_FILTER_ENABLED ? <DesktopSorting /> : <AppliedFilters />}
        {filters}
      </ul>
    </div>
  );
};

export const DesktopFilterMenu = DesktopFilterMenu_Controller;
